var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h6", {}, [_vm._v(_vm._s(_vm.$t(`${_vm.configId}.report.title`)))]),
    _vm._v(" "),
    _c("hr", { staticClass: "mt-2" }),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-3" },
        [
          _c(
            "MaterialSelect",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              staticClass: "city-form-group city-bg",
              attrs: {
                disabled: _vm.disabled,
                id: "input-report",
                name: "report",
                label: "name",
                filterable: true,
                options: _vm.lists.onoff,
                reduce: (option) => option.code,
                inputClasses: [
                  { "is-invalid": _vm.fnHasError("report", _vm.vScope) },
                ],
                error: _vm.fnFirstError("report", _vm.vScope),
                helpText: _vm.helpReport.status,
              },
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.form,
                    "status",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.status",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t(`${_vm.configId}.report.model.status`)) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "MaterialInput",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: _vm.form.status == 1, min: 3 },
                    expression: "{required: form.status == 1, 'min':3}",
                  },
                ],
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                  type: "text",
                  id: "input-report-title",
                  name: "report-title",
                  inputClasses: [
                    {
                      "is-invalid": _vm.fnHasError("report-title", _vm.vScope),
                    },
                  ],
                  error: _vm.fnFirstError("report-title", _vm.vScope),
                },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "title",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.title",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.configId}.report.model.title`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }